import { render, staticRenderFns } from "./SuperBomDetail.vue?vue&type=template&id=600e27e1&scoped=true"
import script from "./SuperBomDetail.vue?vue&type=script&lang=js"
export * from "./SuperBomDetail.vue?vue&type=script&lang=js"
import style0 from "./SuperBomDetail.vue?vue&type=style&index=0&id=600e27e1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600e27e1",
  null
  
)

export default component.exports